import {warehouseDataClient} from 'common/report/queries/app-api/warehouse-data';
import {ApiResource} from 'common/util/model-resource/api-resource';
import {WarehouseImport} from 'common/widgets/warehouse-import-builder/types';

export class WarehouseDataResource extends ApiResource<WarehouseImport> {
  apiClient = warehouseDataClient;
}
